export default "__VITE_ASSET__CdFlVwwM__"